export const SET_LOGGEDIN = 'setLoggedIn'
export const SET_USERNAME = 'setUsername'
export const SET_WALLETS = 'setWallets'
export const UPDATE_WALLETS = 'updateWallets'
